import React from 'react';
import { Box } from 'rebass';
import Link from '../../app/components/link';
import Slider from '../../app/components/slider';
import Details from '../../Details';
import Lead from '../../Lead';
import image1 from '../../app/data/screenshots/pingusenglish/home.jpg';
import image2 from '../../app/data/screenshots/pingusenglish/newsroom.jpg';
import image3 from '../../app/data/screenshots/pingusenglish/kindergarten.jpg';
import image4 from '../../app/data/screenshots/pingusenglish/parents.jpg';

const images = [
  {
    src: image1,
    alt: 'Pingu\'s English home page',
  },
  {
    src: image2,
    alt: 'Pingu\'s English news page',
  },
  {
    src: image3,
    alt: 'Pingu\'s English page design - kindergarten',
  },
  {
    src: image4,
    alt: 'Pingu\'s English page design - parents',
  },
];

const tags = [
  'Education',
  'Wordpress',
  'HTML',
  'CSS',
  'Javascript',
  'Website Deployment',
];

export default () => (
  <div>
    <Details
      title="Pingusenglish"
      subtitle="Education"
    >
      <Details.Paragraph emoji="🐧" title="A beautiful and fun website">
        <Link target="_blank" href="http://pingusenglish.com.cy/">Pingu&apos;s English
      </Link> needed a website to promote their innovative program for early stage children, which
      combines english language teaching with entertainment. Their vision was to create a great
      looking web presence, that is inline with their branding, and can accommodate the vast amount
      of information about their product, without sacrificing usability.
      </Details.Paragraph>
      <Details.Paragraph emoji="❤️" title="Who said Wordpress?">
        We worked together with Pingu&apos;s English Cyprus to develop a Wordpress-based solution
        that allows to easily self-manage their website. Using a simple and easy-to-use interface,
        our client is now able to post news articles, images & video, create new pages,
        and manage accounts. No technical skills required. 🙌
      </Details.Paragraph>
      <Details.Paragraph emoji="🌐" title="A global English teaching program for children">
        Pingu&apos;s English is a franchise operation founded in 2008 and is established in over
        20 countries around the world, including UK, Italy, China, Singapore, and Japan.
      </Details.Paragraph>
      <Details.Tags
        tags={tags}
        width="100%"
      />
      <Slider images={images} />
      <Box mt={5}>
        <Lead />
      </Box>
    </Details>
  </div>
);



// WEBPACK FOOTER //
// ./src/pages/work/pingusenglish.js